<template>
  <dara-single-content-layout container-size="lg">
    <template #content>
      <div class="d-flex align-items--center direction--column">
        <dara-icon size="xxl" icon="question-octagon" />
        <dara-header>{{ $t('you-dont-have-permission-to-access-this-question') }}</dara-header>
        <dara-p>
          {{ $t('the-question-was-specifically-directed-to-a-department-other-than-yours') }}
        </dara-p>
        <br>
        <dara-button theme="primary" @click="goToBasePage()">
          {{ $t('return-to-page') }}
        </dara-button>
      </div>
    </template>
  </dara-single-content-layout>
</template>

<script>
import { goToBasePage } from '@/router/route.service';
import DaraSingleContentLayout from '@/layouts/SingleContentLayout.vue';

export default {
  name: 'DaraQuestionDeniedPage',
  components: {
    DaraSingleContentLayout,
  },
  methods: {
    goToBasePage,
  },
};
</script>
